<span *ngIf="menuItem?.id === 'MARKETING' || menuItem?.id === 'INBOX' || menuItem?.id === 'TRIAGE'" class="m-menu__link-badge">
    <span *ngIf="value > 0" class="m-badge m-badge--danger">{{ value }}</span>
</span>

<asn-hd-status *ngIf="menuItem?.id === 'HELLO_DOCTOR'"></asn-hd-status>

<asn-telephony-status *ngIf="menuItem?.id === 'TELEPHONY'"></asn-telephony-status>
